<template>
  <div class="sidebar-page  is-hidden-touch">
    <section class="sidebar-layout">
      <div position="static" :mobile="mobile" :expand-on-hover="expandOnHover" :reduce="reduce"
           :delay="expandWithDelay ? 500 : null" type="is-light" open>
        <div class="p-1">
          <div class="block">

          </div>
          <b-menu class="is-custom-mobile">
            <b-menu-list label="Files">
              <b-menu-item v-if="isAccess('FBA') || isAccess('FBC')" icon="magnify" label="Consulta">
                <b-menu-item v-if="isAccess('FBA')" icon="file Outline" label="Búsqueda por Archivo" tag="router-link"
                             :to="{ name: 'home.consulta' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FBC')" icon="archive Settings Outline" label="Búsqueda por Caja"
                             tag="router-link" :to="{ name: 'home.consultaPorCaja' }"></b-menu-item>

                <b-menu-item v-if="isAccess('FBCM')" icon="archive Settings Outline" label="Consulta Masiva de Cajas"
                             tag="router-link" :to="{ name: 'home.consultaMasivaPorCaja' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FBAM')" icon="archive Settings Outline" label="Consulta Masiva de Archivo"
                             tag="router-link" :to="{ name: 'home.consultaMasivaPorArchivo' }"></b-menu-item>
              </b-menu-item>
              <b-menu-item v-if="isAccess('FP') || isAccess('FR') || isAccess('FD') || isAccess('FC')" icon="check Bold"
                           label="Solicitudes">
                <b-menu-item v-if="isAccess('FP')" label="Pedidos" tag="router-link"
                             :to="{ name: 'home.pedidos' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FR')" label="Recojos" tag="router-link"
                             :to="{ name: 'home.recojos' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FD')" label="Digitalización" tag="router-link"
                             :to="{ name: 'home.digitalizacion' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FC')" label="Consultas" tag="router-link"
                             :to="{ name: 'home.inquiries' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FL')" label="De baja">
                  <b-menu-item label="Listado de bajas" tag="router-link"
                               :to="{ name: 'home.disposals' }"/>
                  <b-menu-item label="Solicitud de baja" tag="router-link"
                               :to="{ name: 'home.disposals.request' }"/>
                </b-menu-item>
              </b-menu-item>
              <b-menu-item v-if="isAccess('FRP') || isAccess('FRR') || isAccess('FRD') || isAccess('FRA')" icon="poll"
                           label="Reportes">
                <b-menu-item v-if="isAccess('FRP')" label="Reporte de pedidos" tag="router-link"
                             :to="{ name: 'home.reporte-pedidos' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FRR')" label="Reporte de recojos" tag="router-link"
                             :to="{ name: 'home.reporte-recojos' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FRD')" label="Reporte de digitalizacion" tag="router-link"
                             :to="{ name: 'home.reporte-digitalizacion' }"></b-menu-item>
                <b-menu-item v-if="isAccess('FRA')" label="Reporte de archivos" tag="router-link"
                             :to="{ name: 'home.reporte-files' }"></b-menu-item>
              </b-menu-item>
            </b-menu-list>

            <b-menu-list label="Medios">
              <!-- Consulta -->
              <b-menu-item v-if="isAccess('MBM') || isAccess('MBC')" icon="magnify" label="Consulta">
                <b-menu-item v-if="isAccess('MBM')" label="Búsqueda de Medios" tag="router-link"
                             :to="{ name: 'home.consultaMedios' }"></b-menu-item>
                <b-menu-item v-if="isAccess('MBC')" label="Búsqueda de Caja Medios" tag="router-link"
                             :to="{ name: 'home.consultaPorCajaMedios' }"></b-menu-item>
              </b-menu-item>

              <!-- Solicitudes -->
              <b-menu-item v-if="isAccess('MP') || isAccess('MR')" icon="check Bold" label="Solicitudes">
                <b-menu-item v-if="isAccess('MP')" label="Pedidos" tag="router-link"
                             :to="{ name: 'home.pedido-medios' }"></b-menu-item>

                <b-menu-item v-if="isAccess('MR')" label="Recojos">
                  <b-menu-item label="Listado de recojos" tag="router-link"
                               :to="{ name: 'home.media.pickups.list' }"/>
                  <b-menu-item label="Solicitud de recojo" tag="router-link"
                               :to="{ name: 'home.media.pickups.request' }"/>
                </b-menu-item>
              </b-menu-item>

              <!-- Ingresos -->
              <b-menu-item v-if="isAccess('MI')" icon="inbox" label="Ingresos" tag="router-link"
                           :to="{ name: 'home.media.income.list' }"/>

              <!-- Reportes -->
              <b-menu-item v-if="isAccess('MRP') || isAccess('MRR')" icon="poll" label="Reportes">
                <b-menu-item v-if="isAccess('MRP')" label="Reporte de pedidos" tag="router-link"
                             :to="{ name: 'home.reporte-pedidos-medios' }"></b-menu-item>
                <b-menu-item v-if="isAccess('MRR')" label="Reporte de recojos" tag="router-link"
                             :to="{ name: 'home.reporte-recojos-medios' }"></b-menu-item>
                <b-menu-item v-if="isAccess('MRP') || isAccess('MRR')" label="Reporte de cajas" tag="router-link"
                             :to="{ name: 'home.reporte-cajas-medios' }"></b-menu-item>
              </b-menu-item>
            </b-menu-list>

            <b-menu-list label="Planos">
              <b-menu-item v-if="isAccess('PBP') || isAccess('PBC')" icon="magnify" label="Consulta">
                <b-menu-item v-if="isAccess('PBP')" label="Búsqueda de Planos" tag="router-link"
                             :to="{ name: 'home.consultaPlanos' }"></b-menu-item>
                <b-menu-item v-if="isAccess('PBC')" label="Búsqueda de Caja Planos" tag="router-link"
                             :to="{ name: 'home.consultaPorCajaPlanos' }"></b-menu-item>
              </b-menu-item>
              <b-menu-item v-if="isAccess('PP') || isAccess('PR')" icon="check Bold" label="Solicitudes">
                <b-menu-item v-if="isAccess('PP')" label="Pedidos" tag="router-link"
                             :to="{ name: 'home.pedido-planos' }"></b-menu-item>
                <b-menu-item v-if="isAccess('PR')" label="Recojos">
                  <b-menu-item label="Listado de recojos" tag="router-link"
                               :to="{ name: 'home.blueprint.pickups.list' }"/>
                  <b-menu-item label="Solicitud de recojo" tag="router-link"
                               :to="{ name: 'home.blueprint.pickups.request' }"/>
                </b-menu-item>
              </b-menu-item>
              <b-menu-item v-if="isAccess('PRP') || isAccess('PRR')" icon="poll" label="Reportes">
                <b-menu-item v-if="isAccess('PRP')" label="Reporte de pedidos" tag="router-link"
                             :to="{ name: 'home.reporte-pedidos-planos' }"></b-menu-item>
                <b-menu-item v-if="isAccess('PRR')" label="Reporte de recojos" tag="router-link"
                             :to="{ name: 'home.reporte-recojos-planos' }"></b-menu-item>
              </b-menu-item>
            </b-menu-list>

            <b-menu-list label="Muestras">
              <b-menu-item v-if="isAccess('RBR') || isAccess('RBC')" icon="magnify" label="Consulta">
                <b-menu-item v-if="isAccess('RBR')" label="Búsqueda de Muestras" tag="router-link"
                             :to="{ name: 'home.consultaMuestras' }"></b-menu-item>
                <b-menu-item v-if="isAccess('RBC')" label="Búsqueda de Caja Muestras" tag="router-link"
                             :to="{ name: 'home.consultaPorCajaMuestras' }"></b-menu-item>
              </b-menu-item>
              <b-menu-item v-if="isAccess('RP') || isAccess('RR')" icon="check Bold" label="Solicitudes">
                <b-menu-item v-if="isAccess('RP')" label="Pedidos" tag="router-link"
                             :to="{ name: 'home.pedido-muestras' }"></b-menu-item>
                <b-menu-item v-if="isAccess('RR')" label="Recojos">
                  <b-menu-item label="Listado de recojos" tag="router-link"
                               :to="{ name: 'home.sample.pickups.list' }"/>
                  <b-menu-item label="Solicitud de recojo" tag="router-link"
                               :to="{ name: 'home.sample.pickups.request' }"/>
                </b-menu-item>
              </b-menu-item>
              <b-menu-item v-if="isAccess('RRP') || isAccess('RRR')" icon="poll" label="Reportes">
                <b-menu-item v-if="isAccess('RRP')" label="Reporte de pedidos" tag="router-link"
                             :to="{ name: 'home.reporte-pedidos-muestras' }"></b-menu-item>
                <b-menu-item v-if="isAccess('RRR')" label="Reporte de recojos" tag="router-link"
                             :to="{ name: 'home.reporte-recojos-muestras' }"></b-menu-item>
              </b-menu-item>
            </b-menu-list>

            <b-menu-list label="Abastecimiento">
              <b-menu-item
                v-if="isAccess('PDM') || isAccess('BDS') || isAccess('BDD') || isAccess('CDM') || isAccess('MNP')"
                label="Materiales">
                <b-menu-item v-if="isAccess('MNP')" icon="" label="Pedidos" tag="router-link"
                             :to="{ name: 'home.main-pedido' }"></b-menu-item>

                <b-menu-item
                  v-if="isAccess('MRI') || isAccess('MRS')" label="Recojos">

                  <b-menu-item v-if="isAccess('MRI')" label="Listado de recojos" tag="router-link"
                               :to="{ name: 'home.materials.pickups.list' }"/>

                  <b-menu-item v-if="isAccess('MRI')" label="Solicitud de recojo" tag="router-link"
                               :to="{ name: 'home.materials.pickups.request' }"/>
                </b-menu-item>

                <b-menu-item v-if="isAccess('MIBD')" icon="" label="Importar BD" tag="router-link"
                             :to="{ name: 'home.import-bd' }"></b-menu-item>
                <b-menu-item v-if="isAccess('PDM')" icon="" label="Pedido de Materiales" tag="router-link"
                             :to="{ name: 'home.solicitud-materiales' }"></b-menu-item>
                <b-menu-item v-if="isAccess('BDS')" icon="" label="Bandeja de Socios" tag="router-link"
                             :to="{ name: 'home.bandeja-socios' }"></b-menu-item>
                <b-menu-item v-if="isAccess('BDD')" icon="" label="Bandeja de Digitalización" tag="router-link"
                             :to="{ name: 'home.bandeja-digitalizacion' }"></b-menu-item>
                <b-menu-item v-if="isAccess('RDM')" icon="" label="Recojo de Materiales" tag="router-link"
                             :to="{ name: 'home.recojo-materiales' }"></b-menu-item>
                <b-menu-item v-if="isAccess('CDM')" icon="" label="Consulta de Materiales" tag="router-link"
                             :to="{ name: 'home.consulta-materiales' }"></b-menu-item>
                <b-menu-item v-if="isAccess('CMD')" icon="" label="Consulta de Materiales" tag="router-link"
                             :to="{ name: 'home.consulta-materiales-digitalizacion' }"></b-menu-item>

              </b-menu-item>
              <b-menu-item v-if="isAccess('RRM')" label="Reportes">
                <b-menu-item v-if="isAccess('RRM')" icon="" label="Reporte Registro de Materiales" tag="router-link"
                             :to="{ name: 'home.reporte-materiales' }"></b-menu-item>
                <b-menu-item v-if="isAccess('REM')" icon="" label="Estado de Materiales" tag="router-link"
                             :to="{ name: 'home.estado-materiales' }"></b-menu-item>
              </b-menu-item>
            </b-menu-list>

          </b-menu>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Util from "../util";

export default {
  data() {
    return {
      expandOnHover: true,
      expandWithDelay: true,
      mobile: "reduce",
      reduce: false,
    };
  },
  computed: {
    ...mapGetters({getClient: "auth/getClient"}),
  },
  methods: {
    isAccess(access) {
      let usuarioLogueado = Util.getUser();
      if (usuarioLogueado.access) {
        if (usuarioLogueado.access.length > 0) {
          return usuarioLogueado.access.find((a) => a === access);
        } else {
          return this.getClient.access.find((a) => a === access);
        }
      } else {
        return this.getClient.access.find((a) => a === access);
      }
    },
  },

};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/SidebarV2.vue